import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Switch from 'flarum/common/components/Switch';
import Sortable from 'sortablejs';
import Api from '../utils/Api';
import RoomEditorModal from '../modal/RoomEditorModal';
export default class RoomsTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.rooms = [];
    this.loading = true;
    this.activeSchoolId = vnode.attrs.activeSchoolId;
    this.schools = vnode.attrs.schools || [];
    // v0.18.21 — Sortable 实例句柄 (单 DOM 收敛后只剩 **一个** 实例, v0.5.0t 起的双实例已下线)
    this.sortable = null;
    this.load();
  }

  // r.3 FIX (父组件异步换校区时, attrs 会变, 必须同步):
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (vnode.attrs.activeSchoolId !== this.activeSchoolId) {
      this.activeSchoolId = vnode.attrs.activeSchoolId;
      this.schools = vnode.attrs.schools || [];
      this.destroySortables();
      this.load();
    } else {
      this.schools = vnode.attrs.schools || [];
    }
  }
  async load() {
    try {
      this.loading = true;
      const params = this.activeSchoolId ? {
        school_id: this.activeSchoolId
      } : {};
      this.rooms = await Api.list('rooms', params);
    } catch (e) {
      console.error('load rooms failed', e);
    } finally {
      this.loading = false;
      m.redraw();
      this.rebuildSortables();
    }
  }

  // v0.5.0p 第二阶段 — 拖拽结束 → 重排 this.rooms + POST /reorder (带 school_id)
  //
  // v0.18.21 — 原来的 (evt, mode) 第二参没了: 桌面/移动现在是**同一棵 DOM**,
  // 只有一套顺序, 不再需要按端分别处理。
  async onReorderEnd(evt) {
    if (evt.oldIndex === evt.newIndex) return;
    if (evt.oldIndex == null || evt.newIndex == null) return;
    const [moved] = this.rooms.splice(evt.oldIndex, 1);
    this.rooms.splice(evt.newIndex, 0, moved);
    m.redraw();
    const ids = this.rooms.map(r => r.id);
    const params = this.activeSchoolId ? {
      school_id: this.activeSchoolId
    } : {};
    try {
      // v0.8.10 — 删掉 const r: 这个返回值原来只喂 console 的 log 调用, 日志删了之后没人用了
      await Api.reorder('rooms', ids, params);
    } catch (e) {
      console.error('[Rooms] reorder failed, reverting', e);
      const [back] = this.rooms.splice(evt.newIndex, 1);
      this.rooms.splice(evt.oldIndex, 0, back);
      m.redraw();
    }
  }

  // v0.18.21 — Sortable 只挂 **一个** 实例 (桌面/移动共用 .ZS-rooms-grid 这棵 DOM)
  //
  // 拖动态由 onStart/onEnd 手动打 .is-dragging (见 CSS .ZS-room-card.is-dragging):
  //   Sortable 自带的 ghostClass (ZS-sortable-ghost) 落在**被拖的那张卡**上
  //   (非 fallback 路径实测: 原元素 = 跟着光标走的那张), 拖完必须摘掉,
  //   否则 m.redraw() 不会重置 class 属性, 「拖动态」会一直挂着。
  rebuildSortables() {
    this.destroySortables();
    if (!this.rooms || this.rooms.length < 2) return;
    let attempts = 0;
    const tryMount = () => {
      attempts++;
      const gridEl = document.querySelector('.ZS-rooms-grid');
      if (gridEl && !this.sortable) {
        this.sortable = Sortable.create(gridEl, {
          animation: 150,
          handle: '.ZS-drag-handle',
          ghostClass: 'ZS-sortable-ghost',
          dragClass: 'ZS-sortable-drag',
          onStart: evt => {
            if (evt.item) evt.item.classList.add('is-dragging');
          },
          onEnd: evt => {
            if (evt.item) evt.item.classList.remove('is-dragging');
            this.onReorderEnd(evt);
          }
        });
      }
      if (!gridEl && attempts < 15) setTimeout(tryMount, 100);else if (attempts >= 15 && !gridEl) console.warn('[Rooms] Sortable mount FAILED, rooms=' + this.rooms.length);
    };
    setTimeout(tryMount, 0);
  }
  destroySortables() {
    if (this.sortable) {
      try {
        this.sortable.destroy();
      } catch (e) {}
      this.sortable = null;
    }
    // 兜底: 拖拽途中切校区 / 卸载 tab 时, 把可能残留的拖动态摘干净
    document.querySelectorAll('.ZS-room-card.is-dragging').forEach(el => el.classList.remove('is-dragging'));
  }
  onremove() {
    this.destroySortables();
  }

  // v0.5.0m — 改用 Flarum 原生 ModalManager: app.modal.show(RoomEditorModal, ...)
  openEditor(room) {
    app.modal.show(RoomEditorModal, {
      room: room || null,
      schoolId: this.activeSchoolId,
      onClose: () => this.load()
    });
  }

  // v0.5.0t — 桌面端 Switch onchange 优化: 直接改 this.rooms[idx].status + m.redraw(), 不再走 load()
  // (跟 v0.5.0sa CardTemplate Switch 同款, 避免 4 端 1 PATCH 多余 GET)
  onSwitchChange(r, checked) {
    const newStatus = checked ? 'enabled' : 'disabled';
    Api.update('rooms', r.id, {
      status: newStatus
    }).then(() => {
      const idx = this.rooms.findIndex(x => x.id === r.id);
      if (idx >= 0) {
        this.rooms[idx].status = newStatus;
        m.redraw();
      }
    }).catch(e => {
      console.error('[Rooms] Switch update failed', e);
    });
  }
  async remove(r) {
    if (!confirm('确认删除教室 "' + r.name + '"?')) return;
    await Api.delete('rooms', r.id);
    await this.load();
  }
  schoolName() {
    const s = this.schools.find(x => String(x.id) === String(this.activeSchoolId));
    return s ? s.name : '';
  }

  // v0.18.21 — 拖拽手柄: 独立的 grid area (不再是 absolute 压在色条上)
  // v0.18.22 — 图标换成与「校区」tab 完全同款的纯文本 `⋮⋮` (辉哥 10/19 拍板)
  //   保留 .ZS-drag-handle 类名 ⇒ Sortable 的 handle 选择器无需改动
  //   保留 .ZS-room-grip 类名 ⇒ grid-area:grip 的新布局定位不受影响
  dragHandle() {
    return m("span", {
      className: "ZS-room-grip ZS-drag-handle",
      title: "\u62D6\u52A8\u6392\u5E8F"
    }, "\u22EE\u22EE");
  }

  // v0.18.21 — 教室卡片: **单 DOM** (桌面/移动渲染同一棵), 端差异 100% 来自 CSS grid-template-areas
  //
  // 结构: rail(色条) / head(图标+名称+副标题) / grip(手柄) / stats(容量) / ops(编辑·删除·开关)
  //   - 「节/周」标签彻底删掉 (辉哥 10/19 拍板), 数据位只剩容量, **不接后端、不加字段**
  //   - 状态只由「整卡去色 + 底部开关」表达, 不再渲染徽标节点
  //   - 教室颜色只做身份: 4px 色条 + 16% 底色图标块, 通过 --room-color 传进 CSS
  view() {
    const roomData = this.rooms.map(r => ({
      room: r,
      disabled: r.status === 'disabled'
    }));
    const schoolName = this.schoolName();
    return m("div", null, m("div", {
      className: "ZS-toolbar ZS-room-toolbar"
    }, m("span", {
      className: "ZS-toolbar-title"
    }, m("i", {
      className: "fas fa-house"
    }), "\u6559\u5BA4\u8BBE\u7F6E"), m("span", {
      className: "ZS-toolbar-spacer"
    }), m("span", {
      className: "ZS-toolbar-count"
    }, "\u5171 ", this.rooms.length, " \u4E2A\u6559\u5BA4"), m("button", {
      className: "ZS-btn ZS-toolbar-btn",
      onclick: () => this.openEditor(null)
    }, "+ \u65B0\u5EFA\u6559\u5BA4")), this.loading ? m("div", {
      style: "padding:60px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u52A0\u8F7D\u4E2D...") : m("div", null, m("div", {
      className: "ZS-rooms-grid"
    }, roomData.map(_ref => {
      let {
        room: r,
        disabled
      } = _ref;
      return m("div", {
        className: 'ZS-room-card' + (disabled ? ' disabled' : ''),
        key: r.id,
        style: {
          '--room-color': r.color || 'var(--zs-brand-2d7be5, #2D7BE5)'
        }
      }, m("span", {
        className: "ZS-room-rail"
      }), m("div", {
        className: "ZS-room-head"
      }, m("span", {
        className: "ZS-room-icon"
      }, m("i", {
        className: "fas fa-location-dot"
      })), m("div", {
        className: "ZS-room-titles"
      }, m("div", {
        className: "ZS-room-title"
      }, r.name), m("div", {
        className: "ZS-room-sub"
      }, schoolName))), this.dragHandle(), m("div", {
        className: "ZS-room-stats"
      }, m("div", {
        className: "ZS-room-stat"
      }, m("i", {
        className: "fas fa-users"
      }), m("span", {
        className: "ZS-room-stat-value"
      }, r.capacity), m("span", {
        className: "ZS-room-stat-unit"
      }, "\u4EBA"))), m("div", {
        className: "ZS-room-ops"
      }, m("button", {
        className: "ZS-room-btn",
        onclick: () => this.openEditor(r)
      }, "\u7F16\u8F91"), m("button", {
        className: "ZS-room-btn is-danger",
        onclick: () => this.remove(r)
      }, "\u5220\u9664"), m("span", {
        className: "ZS-room-ops-spacer"
      }), m("span", {
        className: "ZS-room-toggle"
      }, m("span", {
        className: "ZS-room-toggle-label"
      }, disabled ? '停用' : '启用'), m(Switch, {
        state: !disabled,
        onchange: checked => this.onSwitchChange(r, checked)
      }))));
    }), this.rooms.length === 0 && m("div", {
      className: "ZS-rooms-empty"
    }, "\u6682\u65E0\u6559\u5BA4"))));
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/components/RoomsTab', RoomsTab);